import { createStyles } from 'antd-style';

export const useAccountDropdownStyles = createStyles(({ token }) => ({
  userLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    marginRight: 12,
  },
  accountUserName: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    marginLeft: 5,
    fontSize: 16,
    fontWeight: 500,
    color: token.colorText,
  },
  accountUserNameEllipsis: {
    maxWidth: 125,
    minWidth: 0,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  accountAdmin: {
    fontWeight: 900,
    color: token.colorPrimary,
    borderBottom: `3px solid ${token.colorPrimary}`,
  },
}));
